import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function customValidator(regex: RegExp): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const valid = regex.test(control.value);
    return valid ? null : { input: { value: control.value } };
  };
}
